import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Api } from 'src/app/providers/app/api.prov';


@Injectable()
export class audioVisualOccupationProvider {
    constructor(public api: Api) { }

    getAll() {
        return this.api.get(`audiovisual`)
            .pipe(map(res => res.json()));
    }

    newOccupation(data) {
        return this.api.post(`audiovisual/create`, data)
            .pipe(map(res => res.json()));
    }


    updateOccupation(id, data) {
        return this.api.put(`audiovisual/update/${id}`, data)
            .pipe(map(res => res.json()));
    }

    getDate(id, data) {
        return this.api.get(`audiovisual/${id}`, data)
            .pipe(map(res => res.json()));
    }
}
